import { TimeUtils } from './timeUtils.js'
import { ObveznaLiga } from '../constants.js'

// Holds any helpers for rounds, such as calculations
export const RoundUtils = {
    // Returns false or the route to go to (question)
    startRound (round) {
        if (TimeUtils.timeUntilFutureTimestamp(round.startTime) <= 0 && TimeUtils.timeUntilFutureTimestamp(round.endTime) > 0) {
            let questionIds = Object.keys(round.questions)
            if (questionIds.length > 0) {
                return `/pitanje/${this.getCurrentQuestionId(round)}`
            }
        }
        return false
    },

    getCurrentQuestionId (round) {
        let questionIds = Object.keys(round.questions)
        let roundStartTime = round.startTime
        let questionsTime = 0
        for (let i = 0; i < questionIds.length; i++) {
            let key = questionIds[i]
            let question = round.questions[key]
            let questionStartTime = roundStartTime + questionsTime
            questionsTime += question.time
            let questionEndTime = questionStartTime + question.time
            if (TimeUtils.timeUntilFutureTimestamp(questionEndTime) >= 0) {
                return key
            }
        }
    },

    convertLigaIndexToString (ligaIndex) {
        try {
            return ObveznaLiga[ligaIndex] ? ObveznaLiga[ligaIndex] : ''
        } catch (error) {
            return ''
        }
    }
}
